import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import {
  IonButton,
  IonIcon,
  IonInput,
  IonPage,
  IonSpinner,
} from '@ionic/react';
import { lockClosedOutline, alertCircleOutline, peopleOutline, eyeOutline, eyeOffOutline, personOutline } from 'ionicons/icons';
import { API_BASE_URL } from '../../config';
import { useUser } from '../../context/UserContext';
import { AppBackground } from '../../components/PageHeader';
import './login.css';

const Login: React.FC = () => {
  const history = useHistory();
  const { setUser } = useUser();
  const [usuario, setusuario] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setError(null);

    try {
      const response = await fetch(`${API_BASE_URL}/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ nickname: usuario, password: password }),
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al iniciar sesión');
        return;
      }


      localStorage.setItem('token', data.token);
      setUser(data.user);

      // Guarda la fecha de login
      localStorage.setItem('loginTime', Date.now().toString());

      history.push('/panel');


    } catch (err) {
      setError('No se pudo conectar con el servidor. Verifica que el backend esté activo.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <IonPage className="app-page login-page">
      <AppBackground variant="auth" />

      <div className="login-wrapper">
        <div className="login-logo">
          <div className="logo-circle">
            <IonIcon icon={peopleOutline} />
          </div>
          <h2 className="app-name">Referidos</h2>
        </div>

        <div className="login-card">
          <h1 className="login-title">Bienvenido</h1>
          <p className="login-subtitle">Inicia sesión para continuar</p>

          <form onSubmit={handleSubmit} className="app-form">
            <div className="input-group">
              <span className="input-icon">
                <IonIcon icon={personOutline} />
              </span>
              <IonInput
                type="text"
                placeholder="Ingrese su usuario"
                value={usuario}
                onIonInput={(e: any) => setusuario(e.detail.value ?? '')}
                className="app-input"
                required
              />
            </div>

            <div className="input-group">
              <span className="input-icon">
                <IonIcon icon={lockClosedOutline} />
              </span>
              <IonInput
                type={showPassword ? 'text' : 'password'}
                placeholder="Contraseña"
                value={password}
                onIonInput={(e: any) => setPassword(e.detail.value ?? '')}
                className="app-input"
                required
              />
              <span
                className="input-icon-right"
                onClick={() => setShowPassword(!showPassword)}
              >
                <IonIcon icon={showPassword ? eyeOffOutline : eyeOutline} />
              </span>
            </div>
            <Link className="app-link forgot-link" to="/recuperar-contrasena">¿Olvidaste tu contraseña?</Link>

            {error && (
              <div className="status-alert alert-error">
                <IonIcon icon={alertCircleOutline} />
                <span>{error}</span>
              </div>
            )}

            <IonButton
              type="submit"
              expand="block"
              className="app-btn-primary"
              disabled={loading}
            >
              {loading ? <IonSpinner name="crescent" /> : 'Iniciar Sesión'}
            </IonButton>
          </form>
        </div>
      </div>
    </IonPage>
  );
};

export default Login;